import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { createGenericNameSchema } from 'utils/yupSchemas/createGenericNameSchema'

export interface AddWalletSchemaProps {
  walletName?: string
  currency?: string
  walletProfileReference?: string
}

export const addWalletSchema = (t: TFunction<'translation', undefined>) => {
  const walletName = createGenericNameSchema(t('customers.walletName'), t, 2)?.required()
  const currency = yup.string().label(t('currency')).required()
  const walletProfileReference = yup.string().label(t('currency')).required()

  const formFields = {
    walletName,
    currency,
    walletProfileReference,
  }

  return yup.object<Partial<Record<keyof AddWalletSchemaProps, yup.AnySchema>>>(formFields)
}
